import React from "react";
import "./LocationItem.scss";
import { Link } from "@mui/material";

const LocationItem = ({
  locationName,
  locationAddress,
  stockDays,
  locationLinkLabel = "See what's in stock",
  locationLinkUrl,
}) => {
  return (
    <li className="location-item">
      <h4 className="location-item__name">{locationName}</h4>
      <address className="location-item__address">{locationAddress}</address>
      <p className="location-item__stock-days">
        <b>{"Restocks: "}</b>
        {stockDays}
      </p>
      {locationLinkUrl && (
        <Link
          className="location-item__link"
          href={locationLinkUrl}
          aria-label={`${locationLinkLabel} at ${locationName}`}
        >
          {locationLinkLabel}
        </Link>
      )}
    </li>
  );
};

export default LocationItem;
